<div class="document-row">
    <div class="document-fields">
        <mat-form-field class="doc-url-field">
            <mat-label>Coredata slóð</mat-label>
            <input matInput [formControl]="urlControl" (input)="onUrlInput()" (blur)="onUrlBlur()" />
            @if (loading) {
                <mat-progress-spinner matSuffix [diameter]="18" [mode]="'indeterminate'"></mat-progress-spinner>
            }
            @if (urlControl?.hasError('required') && urlControl?.touched) {
                <mat-error>Nauðsynlegt að fylla út Coredata slóð.</mat-error>
            }
            @if (urlControl?.hasError('invalidCoredataUrl') && urlControl?.touched) {
                <mat-error>Ógild Coredata slóð.</mat-error>
            }
            @if (urlControl?.hasError('fileNameEmpty') && urlControl?.touched) {
                <mat-error>Þessi slóð vísar ekki í skrá.</mat-error>
            }
        </mat-form-field>
        <mat-form-field class="doc-name-field">
            <mat-label>Skráarheiti</mat-label>
            <input matInput [formControl]="fileNameControl" [readonly]="!fileNameIsResolved" />
            @if (fileNameControl?.invalid && fileNameControl?.touched) {
                <mat-error>Nauðsynlegt að fylla út skráarheiti.</mat-error>
            }
        </mat-form-field>
    </div>
    @if (showRemove) {
        <button mat-icon-button type="button" (click)="onRemove()" class="remove-doc-btn">
            <mat-icon>remove_circle_outline</mat-icon>
        </button>
    }
</div>
